import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';

import { EnrichedWatchlistFacade } from '../state/enriched-watchlist/enriched-watchlist.facade';
import { ItemCategory } from '../state/enriched-watchlist/enriched-watchlist.models';

@Injectable()
export class WatchlistResolver {
  constructor(private readonly watchlistFacade: EnrichedWatchlistFacade) {}

  resolve(route: ActivatedRouteSnapshot): boolean {
    const pageParam = route.queryParamMap.get('page');
    let page = 1;
    if (pageParam) {
      page = parseInt(pageParam);
    }

    const itemCategoryParam = route.queryParamMap.get('category');
    let itemCategory: ItemCategory | undefined = undefined;
    switch (itemCategoryParam) {
      case ItemCategory.all:
      case ItemCategory.event:
      case ItemCategory.exhibitor:
      case ItemCategory.post:
      case ItemCategory.product:
      case ItemCategory.brand:
        itemCategory = itemCategoryParam;
        break;
      default:
        itemCategory = ItemCategory.all;
    }

    this.watchlistFacade.initWatchlist(--page, itemCategory);
    return true;
  }
}
